import React, { useState, useEffect } from 'react';

import { Form, Button, Breadcrumb } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';

import GroupService from 'Services/GroupService';

const Apps = (props) => {
    const history = useHistory();
    const [group, setGroup] = useState(null);
    const { register, handleSubmit, errors } = useForm();

    const {
        match: { params },
    } = props;

    useEffect(() => {
        if (params.groupId) {
            GroupService.getGroupById(params.groupId)
                .then((result) => {
                    if (result.status === 200) {
                        setGroup(result.data);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [params]);

    const onSubmit = (data) => {
        GroupService.saveGroup({ groupId: params.groupId, ...data })
            .then((result) => {
                if (result.status === 200) {
                    history.push('/admin/group/index');
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item>
                    <Link to="/">Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/admin">Admin</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/admin/group/index">Group</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>{params.groupId ? 'Edit Group' : 'Create New Group'}</Breadcrumb.Item>
            </Breadcrumb>
            <div className="row py-3">
                <div className="col text-center">
                    <h2 className="mb-0">{params.groupId ? 'Edit Group' : 'Create New Group'}</h2>
                    <i style={{ fontSize: '8pt', fontStyle: 'unset' }}>{params.groupId}</i>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6">
                    {errors.exampleRequired && <span>This field is required</span>}

                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="name"
                                name="Name"
                                defaultValue={group ? group.name : ''}
                                ref={register({ required: true })}
                            />
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Description"
                                name="Description"
                                defaultValue={group ? group.description : ''}
                                ref={register({ required: true })}
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" block>
                            Submit
                        </Button>
                    </Form>
                </div>
                <div className="col-md-3"></div>
            </div>
        </>
    );
};

export default Apps;
